import { P2GBox } from '@parcel2go/core-ui';
import { P2GButton } from '@parcel2go/core-ui';
import { P2GContainer } from '@parcel2go/core-ui';
import { P2GDivider } from '@parcel2go/core-ui';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ItemActionType } from '../../smartsend/item/SetMarketplaceAction';
import { PickingListSheet } from './PickingListSheet';
import { printPickingList } from './printPickingList';

interface props {
  items: SmartSendItemApiModel[];
  action: (action: ItemActionType, id: string) => void;
}
export function PickingListAndPrintButton(props: props) {
  return (
    <P2GContainer>
      <P2GBox p={2} textAlign="center">
        <P2GButton onClick={() => printPickingList('PICKINGLISTCONTENT')}>Print</P2GButton>
      </P2GBox>
      <P2GBox pt={2} pb={2}>
        <P2GDivider />
      </P2GBox>
      <div id="PICKINGLISTCONTENT">
        <PickingListSheet working={false} items={props.items} action={props.action} />
      </div>
    </P2GContainer>
  );
}
